import { cn } from '@tripleten/cn';

export const cnPageInternalResetPassword = cn('page-internal-reset-password');
